interface TripCardAddProps {
  icon: string;
  text: string;
  text2?: string;
  textBtnNext?: string;
  textBtnDownload?: string;
  onNext?: () => void;
  onDownload?: () => void;
  onClick?: () => void;
  isActive?: boolean;
}

const TripCardAdd = ({ 
  icon, 
  onNext, 
  onDownload, 
  text, 
  text2 = " ", 
  textBtnNext, 
  textBtnDownload,
  onClick,
  isActive = false
}: TripCardAddProps) => {
  return (
    <div
      className={`
        display-flex 
        flex-column 
        gap-24 
        border-width-1 
        border-style-solid 
        rounded 
        justify-content-center 
        align-items-center 
        shadow-default 
        border-color-gray
        margin-10
        cursor-pointer
        transition-all
        duration-200
        ${onClick ? "hover-bg-highlight-lightest hover-shadow-lg" : ""}
        ${isActive ? "bg-highlight-lightest border-color-primary" : ""}
        flex-1-1
      `}
      onClick={onClick}
    >
      <div className={`
        border 
        border-color-primary 
        border-width-3 
        border-style-solid 
        display-flex 
        justify-content-center 
        align-items-center
        margin-top-20
        width-50
        height-50
      `}>
        <span className={`${icon} text-size-h1 text-color-primary`} />
      </div>
      <div className={`display-flex flex-column margin-y-20 justify-content-center align-items-center`}>
        <span className="text-size-16 line-height-20 text-normal margin-x-20 height-20">{text}</span>
        <span className={`text-size-13 text-normal text-color-status-resting margin-x-20 margin-top-5 height-20`}>{text2}</span>
      </div>
      <div className="display-flex flex-row gap-10 margin-bottom-20 margin-top-20">
        {textBtnDownload && onDownload && (
          <button
            type="button"
            className="btn btn-default btn-lg"
            onClick={(e) => {
              e.stopPropagation();
              onDownload();
            }}
          >
            <span className="text-capitalize">{textBtnDownload}</span>
          </button>
        )}
        {textBtnNext && onNext && (
          <button
            type="button"
            className="btn btn-primary btn-lg"
            onClick={(e) => {
              e.stopPropagation();
              onNext();
            }}
          >
            <span className="text-capitalize">{textBtnNext ?? "Continuar"}</span>
          </button>
        )}
      </div>
    </div>
  );
};

export default TripCardAdd; 